import React, { useState, useEffect } from 'react';
import { XTableCell } from '../components/table/XTableCell';
import { XR } from '../../xr';
import { isArray } from '../../util/isArray';
export function useCheckboxes(models, options) {
    var _a = useState(new Set()), checked = _a[0], setChecked = _a[1];
    var numChecked = checked.size;
    var mapValue = (options === null || options === void 0 ? void 0 : options.mapValue) || (function (model) { var _a; return (_a = model === null || model === void 0 ? void 0 : model.id) !== null && _a !== void 0 ? _a : model; });
    var isCheckable = (options === null || options === void 0 ? void 0 : options.isCheckable) || (function () { return true; });
    var checkableModels = models.filter(isCheckable);
    var isAllChecked = numChecked === checkableModels.length && numChecked > 0;
    useEffect(function () {
        reset();
    }, [checkableModels.length]);
    function reset() {
        setChecked(new Set());
    }
    function getHeaderCell() {
        if (checkableModels.length === 0) {
            return React.createElement("td", null);
        }
        return (React.createElement(XTableCell, { type: 'checkbox', checked: isAllChecked, disabled: checkableModels.length === 0, onChangeValue: function () {
                if (isAllChecked) {
                    reset();
                }
                else {
                    setChecked(new Set(checkableModels.map(mapValue)));
                }
            } }));
    }
    function getCell(model) {
        if (!isCheckable(model)) {
            return React.createElement("td", null);
        }
        var value = mapValue(model);
        return (React.createElement(XTableCell, { type: 'checkbox', checked: checked.has(value), onChangeValue: function () { return handleValueChange(value); } }));
    }
    function getCheckbox(model) {
        if (!isCheckable(model)) {
            return null;
        }
        var value = mapValue(model);
        var isChecked = checked.has(value);
        return (React.createElement(XR.Button, { onClick: function () {
                handleValueChange(value);
            }, style: { height: '100%', borderRadius: 0 }, variant: 'text', color: isChecked ? 'primary' : 'washed', icon: isChecked ? 'check_box' : 'check_box_outline_blank' }));
    }
    function handleValueChange(value) {
        setChecked(function (previous) {
            var checked = new Set(previous);
            if (checked.has(value)) {
                checked.delete(value);
            }
            else {
                checked.add(value);
            }
            return checked;
        });
    }
    function isChecked(item) {
        var values = (isArray(item) ? item : [item]);
        return values.length === values.map(mapValue).filter(function (value) { return checked.has(value); }).length;
    }
    function toggleItem(item, action) {
        var _a, _b;
        if (action === 'add' && !isCheckable(item)) {
            return;
        }
        var value = mapValue(item);
        if (!action) {
            return handleValueChange(value);
        }
        setChecked(function (state) {
            var checked = new Set(state);
            if (action === 'add') {
                checked.add(value);
            }
            if (action === 'delete') {
                checked.delete(value);
            }
            return checked;
        });
        if (action === 'add') {
            (_a = options === null || options === void 0 ? void 0 : options.onAdd) === null || _a === void 0 ? void 0 : _a.call(options, value);
        }
        else if (action === 'delete') {
            (_b = options === null || options === void 0 ? void 0 : options.onRemove) === null || _b === void 0 ? void 0 : _b.call(options, value);
        }
    }
    function setValues(values) {
        setChecked(new Set(values.map(mapValue)));
    }
    return {
        checkedValues: Array.from(checked),
        isAnyChecked: numChecked > 0,
        isAllChecked: isAllChecked,
        isChecked: isChecked,
        toggleItem: toggleItem,
        reset: reset,
        setValues: setValues,
        element: {
            getCheckbox: getCheckbox,
            getHeaderCell: getHeaderCell,
            getCell: getCell,
            getGroupCell: function (models) {
                var checkable = models.filter(isCheckable);
                if (checkable.length === 0) {
                    return React.createElement("td", null);
                }
                var isAllChecked = checkable.length === checkable.filter(isChecked).length;
                return (React.createElement(XTableCell, { type: 'checkbox', checked: isAllChecked, onChangeValue: function () {
                        checkable.forEach(function (model) {
                            toggleItem(model, isAllChecked ? 'delete' : 'add');
                        });
                    } }));
            },
        },
        table: {
            getHeaderCell: getHeaderCell,
            getCell: getCell,
        },
    };
}
